// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5b7d68b","952":"f60f98d9"}[chunkId] + ".chunk.js";
};